<ng-template #manualEntry>
    <mat-label class="subHeading">{{label}}<span *ngIf="isRequired" class="star">*</span></mat-label>
    <input formControlName="{{controlName}}" type="text" (blur)="transformValue()" class="mt-2"
        placeholder="policy intermediary code" />
</ng-template>

<div *ngIf="fromFile; else manualEntry" class="row">
    <div class="col-12">
        <mat-label>{{label}}<span *ngIf="isRequired" class="star">*</span></mat-label>
        <textarea class="mt-1 form-control" style="resize: none;" [rows]="4" formControlName="{{controlName}}"
            type="text" (blur)="transformValue()"></textarea>
    </div>
    <div class="col-8">
        <app-file-field [label]="'CSV Upload'" [acceptOnly]="['text/csv']"
            (fileUploaded)="onCsvUpload($event)"></app-file-field>
        <p>
            <span> Click Here To </span>
            <a class="downloadFile"
                href="https://rb-dev-transcripts.s3.ap-south-1.amazonaws.com/template/sample_csv.csv"
                target="_blank"><span>Download Template</span></a>
        </p>
    </div>
</div>